import { useState, useEffect } from "react"
import { TrendingUp, TrendingDown, Users, FileText, Package, ShoppingCart } from "lucide-react"
import axios from "axios"

export default function DashboardPage() {
  const [dashboardData, setDashboardData] = useState(null)
  const [latestProducts, setLatestProducts] = useState([])
  const [latestSales, setLatestSales] = useState([])
  const [latestPurchases, setLatestPurchases] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchDashboardData()
    fetchLatestProducts()
    fetchLatestSales()
    fetchLatestPurchases()
  }, [])

  const fetchDashboardData = async () => {
    try {
      setIsLoading(true)
      setError(null)
      
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/dashboard`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )

      if (response.data) {
        setDashboardData(response.data)
      }
    } catch (err) {
      console.error("Error fetching dashboard data:", err)
      setError(err.response?.data?.message || "Failed to fetch dashboard data")
    } finally {
      setIsLoading(false)
    }
  }

  const fetchLatestProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/last-5-products`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )

      if (response.data && response.data.products) {
        setLatestProducts(response.data.products)
      } else {
        setLatestProducts([])
      }
    } catch (err) {
      console.error("Error fetching latest products:", err)
      setLatestProducts([])
    }
  }

  const fetchLatestSales = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/latest-sales`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )

      if (response.data && response.data.latest_sales) {
        setLatestSales(response.data.latest_sales)
      } else {
        setLatestSales([])
      }
    } catch (err) {
      console.error("Error fetching latest sales:", err)
      setLatestSales([])
    }
  }

  const fetchLatestPurchases = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/latest-purchases`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )

      if (response.data && response.data.latest_purchases) {
        setLatestPurchases(response.data.latest_purchases)
      } else {
        setLatestPurchases([])
      }
    } catch (err) {
      console.error("Error fetching latest purchases:", err)
      setLatestPurchases([])
    }
  }

  const stats = [
    {
      title: "Total Purchase",
      value: "₹ 307,144",
      icon: Package,
      color: "bg-orange-500",
    },
    {
      title: "Total Sales",
      value: "₹ 300,140",
      icon: ShoppingCart,
      color: "bg-green-500",
    },
    {
      title: "Purchase Return",
      value: "₹ 4,000",
      icon: TrendingDown,
      color: "bg-blue-500",
    },
    {
      title: "Sales Return",
      value: "₹ 400",
      icon: TrendingUp,
      color: "bg-red-500",
    },
  ]

  const infoCards = [
    {
      title: "No of Employees",
      value: dashboardData?.employee_count || "100",
      icon: Users,
      color: "bg-orange-500",
    },
    {
      title: "Last Login Time",
      value: "19 May 2025 1:48 pm",
      color: "bg-blue-500",
    },
    {
      title: "No of Purchase Added",
      value: dashboardData?.purchase_records_count || "150",
      icon: FileText,
      color: "bg-slate-700",
    },
    {
      title: "No of Sales Added",
      value: dashboardData?.sales_records_count || "170",
      icon: FileText,
      color: "bg-green-500",
    },
  ]

  return (
    <div className="space-y-6 -mt-4">
      {/* Stats Cards */}
      {/* <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat, index) => (
          <div key={index} className="bg-white rounded-lg shadow p-4">
            <div className="flex flex-row items-center justify-between pb-2">
              <span className="text-sm font-medium text-gray-500">{stat.title}</span>
              <div className={`rounded-full p-2 ${stat.color}`}>
                <stat.icon className="h-4 w-4 text-white" />
              </div>
            </div>
            <div className="text-2xl font-bold">{stat.value}</div>
          </div>
        ))}
      </div> */}

      {/* Info Cards */}
      {/* <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {infoCards.map((card, index) => (
          <div key={index} className={`${card.color} text-white rounded-lg shadow p-4`}>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-lg font-bold">{card.value}</p>
                <p className="text-xs opacity-90">{card.title}</p>
              </div>
              {card.icon && <card.icon className="h-8 w-8 opacity-80" />}
            </div>
          </div>
        ))}
      </div> */}

      {/* Recently Added Products */}
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b">
          <span className="text-lg font-semibold">Recently Added Products</span>
        </div>
        <div className="p-4 overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Product Name</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Product Code</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Product Category</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Unit</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Color</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {latestProducts.length > 0 ? (
                latestProducts.map((product, index) => (
                  <tr key={index}>
                    <td className="px-4 py-2 font-medium text-gray-900">{product.product_name}</td>
                    <td className="px-4 py-2">{product.product_master_code}</td>
                    <td className="px-4 py-2">{product.category_name}</td>
                    <td className="px-4 py-2">{product.product_unit}</td>
                    <td className="px-4 py-2">{product.product_color}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="px-4 py-2 text-center text-gray-500">No products to display</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Recent Purchases and Sales */}
      <div className="grid gap-6 md:grid-cols-2">
        <div className="bg-white rounded-lg shadow">
          <div className="p-4 border-b">
            <span className="text-lg font-semibold">Recent 5 Purchases</span>
          </div>
          <div className="p-4">
            {latestPurchases.length > 0 ? (
              <div className="space-y-4">
                {latestPurchases.map((purchase, index) => (
                  <div key={index} className="flex justify-between items-center py-2 border-b last:border-0">
                    <div>
                      <p className="font-medium text-gray-900">{purchase.product_name}</p>
                      <p className="text-sm text-gray-500">{purchase.product_master_code}</p>
                      <p className="text-sm text-gray-500">{purchase.category_name} • {purchase.product_unit} • {purchase.product_color}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-medium text-gray-900">₹ {purchase.total_price}</p>
                      <p className="text-sm text-gray-500">{purchase.quantity_purchased} units</p>
                      <p className="text-sm text-gray-500">₹ {purchase.purchase_price_per_unit}/unit</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-500">No recent purchases to display</p>
            )}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow">
          <div className="p-4 border-b">
            <span className="text-lg font-semibold">Recent 5 Sales</span>
          </div>
          <div className="p-4">
            {latestSales.length > 0 ? (
              <div className="space-y-4">
                {latestSales.map((sale, index) => (
                  <div key={index} className="flex justify-between items-center py-2 border-b last:border-0">
                    <div>
                      <p className="font-medium text-gray-900">{sale.product_name}</p>
                      <p className="text-sm text-gray-500">{sale.product_master_code}</p>
                      <p className="text-sm text-gray-500">{sale.category_name} • {sale.product_unit} • {sale.product_color}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-medium text-gray-900">₹ {sale.total_price}</p>
                      <p className="text-sm text-gray-500">{sale.quantity_sold} units</p>
                      <p className="text-sm text-gray-500">₹ {sale.selling_price_per_unit.toFixed(2)}/unit</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-500">No recent sales to display</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
